import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { css } from '@emotion/react'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import Tooltip from '@groovehq/internal-design-system/lib/components/Tooltip/Tooltip'
import { styles as menuStyles } from '@groovehq/internal-design-system/lib/components/Menu/Menu.styles'
import { SVGIcon } from 'shared/ui'
import { selectIsMatrixClientReady } from 'ducks/chat/selectors/client'
import { doUpdateAudioNotificationsFromUI } from 'ducks/chat/actions/notifications'
import { selectNotificationsEnabled } from 'ducks/chat/selectors/notifications'
import { isDenied } from 'util/webPush/permissions'

// irregularly sized icon, overwrite the dimension set my design system
const svgIconStyle = css`
  && {
    width: 16px;
    height: 16px;
  }
`

const NotificationsButton = props => {
  const clientReady = useSelector(selectIsMatrixClientReady)
  const enabled = useSelector(selectNotificationsEnabled)
  const dispatch = useDispatch()
  const onToggle = useCallback(
    () => {
      if (isDenied()) return
      dispatch(doUpdateAudioNotificationsFromUI(!enabled))
    },
    [dispatch, enabled]
  )

  if (!clientReady) return null

  return (
    <div {...props}>
      <Tooltip
        position="bottom"
        key="link"
        title="You have blocked notifications in your browser permissions."
        disabled={!isDenied()}
      >
        <Button
          type="icon"
          size="small"
          onClick={onToggle}
          css={menuStyles.controlIconButton}
          customIcon={
            <SVGIcon
              name={`notifications${enabled ? 'Active' : 'Off'}`}
              css={svgIconStyle}
            />
          }
        />
      </Tooltip>
    </div>
  )
}

export default NotificationsButton
